import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {labels} from '../../../util/utils';

import {IconoirProhibition} from '@ey-xd/motif-icon';

import ProgressLoader from '../../CoreWrappers/ProgressLoader';
import IconMessage from '../../CoreWrappers/IconMessage';
import StyledListWithScroll from './StyledListWithScroll';
import StyledListWithScrollWrapper from './StyledListWithScrollWrapper';

const ListWithScroll = ({
	list = null,
	item = null,
	header = null,
	emptyIcon = IconoirProhibition,
	emptyTitle = labels.thereIsNoDataToDisplay,
	emptySubtitle = null,
	isLoading = false,
	Wrapper = null,
	enableScroll = true,
	includeWrapper = true
}) => {
	if ((!list || !item) && !isLoading) return false;
	const isEmptyList = !list?.length > 0;

	let Component = StyledListWithScroll;
	if (Wrapper) Component = Wrapper;

	const renderEmpty = () => {
		const props = {
			title: emptyTitle,
			icon: emptyIcon,
			className: 'list-with-scroll-empty'
		};
		if (emptySubtitle) props.subTitle = emptySubtitle;

		return <IconMessage {...props} />;
	};

	const renderContent = () => (
		<>
			{!isEmptyList && list.map(item)}
			{isEmptyList && renderEmpty()}
		</>
	);

	const ComponentWrapper = includeWrapper ? StyledListWithScrollWrapper : Fragment;

	const props = {
		className: classNames({customScrollbar: enableScroll})
	};

	return (
		<ComponentWrapper className="list-with-scroll">
			{header && header()}
			{!isLoading && (
				<>
					{enableScroll && <Component {...props}>{renderContent()}</Component>}
					{!enableScroll && renderContent()}
				</>
			)}
			{isLoading && <ProgressLoader />}
		</ComponentWrapper>
	);
};

ListWithScroll.propTypes = {
	list: PropTypes.array,
	item: PropTypes.func,
	header: PropTypes.func,
	emptyTitle: PropTypes.string,
	emptySubtitle: PropTypes.string,
	isLoading: PropTypes.bool,
	enableScroll: PropTypes.bool,
	includeWrapper: PropTypes.bool
};

export default ListWithScroll;
